import { createFileRoute, Outlet } from "@tanstack/react-router";

const Route = createFileRoute("/_authorized/teammates")({
  component: () => <Outlet />,
});

export { Route };
